import { render, staticRenderFns } from "./LinkPayTaahodat.vue?vue&type=template&id=5e138ab8&scoped=true&"
import script from "./LinkPayTaahodat.vue?vue&type=script&lang=js&"
export * from "./LinkPayTaahodat.vue?vue&type=script&lang=js&"
import style0 from "./LinkPayTaahodat.vue?vue&type=style&index=0&id=5e138ab8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e138ab8",
  null
  
)

export default component.exports